import { Component } from '@angular/core';

@Component({
  selector: 'app-borderou',
  templateUrl: './borderou.component.html',
  styleUrls: ['./borderou.component.scss']
})
export class BorderouComponent {

}
